<template>
  <div ref="chartRef" class="chart"></div>
</template>

<script setup>
import * as echarts from "echarts";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";

const props = defineProps({
  xData: {
    type: Array,
    default: () => [],
  },
  soilTemperatureData: {
    type: Array,
    default: () => [],
  },
  soilMoistureData: {
    type: Array,
    default: () => [],
  },
});

const chartRef = ref(null);
let chartInstance = null;

const option = {
  color: ["#2fd7d1", "#9ce286", "#b9f0b8", "#70d8ff"],
  grid: { top: 80, left: 62, right: 36, bottom: 45 },
  legend: {
    top: 30,
    right: 26,
    itemWidth: 30,
    itemHeight: 10,
    itemGap: 40,
    textStyle: { color: "#d8f2ff", fontSize: 22 },
    data: [ "土壤温度", "土壤湿度"],
  },
  tooltip: { trigger: "axis", textStyle: { fontSize: 20 } },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [],
    axisTick: { show: false },
    axisLine: { lineStyle: { color: "rgba(102, 187, 231, .35)" } },
    axisLabel: { color: "#d8f2ff", fontSize: 22 },
  },
  yAxis: [
    {
      type: "value",
      name: "℃",
      min: 0,
      max: 60,
      nameTextStyle: { color: "#d8f2ff", fontSize: 20 },
      axisLabel: { color: "#d8f2ff", fontSize: 22, formatter: (value) => (value === 0 ? "" : value) },
      splitLine: { lineStyle: { color: "rgba(102, 187, 231, .16)" } },
    },
    {
      type: "value",
      name: "%",
      min: 0,
      max: 100,
      nameTextStyle: { color: "#d8f2ff", fontSize: 20 },
      axisLabel: { color: "#d8f2ff", fontSize: 22, formatter: (value) => (value === 0 ? "" : value) },
      splitLine: { show: false },
    }
  ],
  series: [
    makeLine("土壤温度", [], 0),
    makeLine("土壤湿度", [], 1),
  ],
};

function makeLine(name, data, yAxisIndex) {
  return {
    name,
    type: "line",
    smooth: true,
    symbol: "circle",
    symbolSize: 7,
    yAxisIndex,
    lineStyle: { width: 3 },
    areaStyle: { opacity: 0.15 },
    data,
  };
}

function resizeChart() {
  chartInstance && chartInstance.resize();
}

function updateChart() {
  if (!chartInstance) return;

  chartInstance.setOption({
    xAxis: {
      data: props.xData,
    },
    series: [
      {
        data: props.soilTemperatureData,
      },
      {
        data: props.soilMoistureData,
      },
    ],
  });
}

onMounted(() => {
  chartInstance = echarts.init(chartRef.value);
  chartInstance.setOption(option);
  updateChart();
  window.addEventListener("resize", resizeChart);
});

watch(
  () => [props.xData, props.soilTemperatureData, props.soilMoistureData],
  updateChart,
  { deep: true }
);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  chartInstance && chartInstance.dispose();
});
</script>

<style lang="less" scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
